import AllSidesInput from "../../../general/AllSidesInput";
import { AllSidesInputInit } from "../../../general/AllSidesInput";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import SidebarCollapse from "../../../app/SidebarCollapse";
import { EditableProps } from "../../editableProps";
import { updateNodeProperty } from "../../../../store/slices/BuilderSlice/builderSlice";
import { getValueUnit } from "../../../general/editUtils";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { getStyle, getStylePath } from "@builder/components/editable/helpers";

const Spacing: React.FC<EditableProps> = ({ parent, path, title, excluded, noWrapper, condition, stateMode }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode);
    const cvMode = useAppSelector(state => state.builder.conditionalVariationMode);
    const cvModeIndex = cvMode?.id === node?.id ? cvMode.index : null;

    if (!node) return null;

    const styles = getStyle(node, path, stateMode, cvModeIndex);
    const stylePath = getStylePath(path, stateMode, cvModeIndex);

    //Padding
    let paddingContent = null;
    if (!excluded?.includes("padding")) {
        const paddingArray = (styles.stateStyle?.padding || styles.default?.padding)?.split(" ");
        const paddingInit: AllSidesInputInit = paddingArray
            ? {
                  top: getValueUnit(paddingArray[0]),
                  right: getValueUnit(paddingArray[1]),
                  bottom: getValueUnit(paddingArray[2]),
                  left: getValueUnit(paddingArray[3])
              }
            : {
                  top: { value: "", unit: "px" },
                  right: { value: "", unit: "px" },
                  bottom: { value: "", unit: "px" },
                  left: { value: "", unit: "px" }
              };
        const paddingCallback = (values: AllSidesInputInit) => {
            dispatch(
                updateNodeProperty({
                    propertyPath: [...stylePath, "padding"],
                    value: `${values.top.value + values.top.unit} ${values.right.value + values.right.unit} ${
                        values.bottom.value + values.bottom.unit
                    } ${values.left.value + values.left.unit}`
                })
            );
        };
        paddingContent = <AllSidesInput title="Padding" init={paddingInit} callback={paddingCallback} />;
    }

    let marginContent = null;
    if (!excluded?.includes("margin")) {
        const marginArray = (styles.stateStyle?.margin || styles.default?.margin)?.split(" ");
        const marginInit: AllSidesInputInit = marginArray
            ? {
                  top: getValueUnit(marginArray[0]),
                  right: getValueUnit(marginArray[1]),
                  bottom: getValueUnit(marginArray[2]),
                  left: getValueUnit(marginArray[3])
              }
            : {
                  top: { value: "", unit: "px" },
                  right: { value: "", unit: "px" },
                  bottom: { value: "", unit: "px" },
                  left: { value: "", unit: "px" }
              };
        const marginCallback = (values: AllSidesInputInit) => {
            dispatch(
                updateNodeProperty({
                    propertyPath: [...stylePath, "margin"],
                    value: `${values.top.value + values.top.unit} ${values.right.value + values.right.unit} ${
                        values.bottom.value + values.bottom.unit
                    } ${values.left.value + values.left.unit}`
                })
            );
        };
        marginContent = <AllSidesInput title="Margin" init={marginInit} callback={marginCallback} />;
    }

    if (condition && (!node || !condition(node))) return null;

    if (noWrapper) {
        return (
            <>
                {paddingContent}
                {marginContent}
            </>
        );
    } else {
        return (
            <SidebarCollapse title={title || "Spacing"} parent={parent}>
                {paddingContent}
                {marginContent}
            </SidebarCollapse>
        );
    }
};

export default Spacing;
